/* The "Operating at scale" band of the home page, for the product and collection pages: same words, same three rows of businesses moving
   in opposite directions, same look (it is the ProofStrip of the home page, written without React so any page can place it).
   A page marks the spot with <div id="wb-proof-slot"></div>; the band fills it, and fills it again if the page redraws that spot. */
(function () {
  'use strict';
  /* [name, optical size factor]: the businesses running on the AI Phone platform, shown as type exactly as on the home page */
  var ROWS = [
    [['Lenovo', 1.06], ['Anker', 1], ['Everise', 1], ['Asbury Automotive Group', .82], ['Varsity Tutors', .9], ['GiftHealth', .94], ['SWTCH', 1.02], ['Matic', 1.04], ['Ro', 1.18]],
    [['TripleTen', .98], ['Cents', 1.06], ['Pine Park Health', .86], ['SpareLabs', .96], ['Sunshine Loans', .88], ['Boatzon', 1], ['Inbounds.com', .92], ['iSpeedToLead', .9], ['Mercor', 1.04]],
    [['Medical Data Systems', .82], ['BrightChamps', .92], ['AccioJob', .98], ['Doxy.me', 1.04], ['Respaid', 1.02], ['StorageVault', .9], ['SmartEnergy.com', .86], ['Luna Physical Therapy', .82]]
  ];
  var DIRS = [['wbProofL', 82], ['wbProofR', 97], ['wbProofL', 89]];
  var CSS = '@keyframes wbProofL{from{transform:translateX(-25%)}to{transform:translateX(0)}}' +
    '@keyframes wbProofR{from{transform:translateX(0)}to{transform:translateX(-25%)}}' +
    '#wb-proof-slot{width:100%;max-width:none!important;align-self:stretch;min-width:0;margin:clamp(22px,2.6vw,36px) 0}' +
    '#social-proof .wb-proof-logo:hover{opacity:1;color:var(--ink-900);filter:none}' +
    '#social-proof .wb-proof-vp:hover .wb-proof-track{animation-duration:calc(var(--wb-proof-dur) * 1.75)}' +
    '@media(max-width:820px){#social-proof .wb-proof-row-3{display:none}}' +
    '@media(prefers-reduced-motion:reduce){#social-proof .wb-proof-track{animation:none!important;width:auto!important;flex-wrap:wrap;justify-content:center;row-gap:26px}' +
    '#social-proof .wb-proof-vp{mask-image:none!important;-webkit-mask-image:none!important}#social-proof .wb-proof-logo:nth-child(n+10){display:none}}';

  function make(tag, cls, css, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (css) e.style.cssText = css;
    if (text != null) e.textContent = text;
    return e;
  }

  function row(items, i) {
    var vp = make('div', 'wb-proof-vp', 'overflow:hidden;width:100%;min-width:0;mask-image:linear-gradient(90deg,transparent 0,#000 12%,#000 88%,transparent 100%);-webkit-mask-image:linear-gradient(90deg,transparent 0,#000 12%,#000 88%,transparent 100%)');
    var track = make('div', 'wb-proof-track', 'display:flex;align-items:center;gap:clamp(38px,5vw,78px);width:max-content;--wb-proof-dur:' + DIRS[i][1] + 's;animation-name:' + DIRS[i][0] + ';animation-duration:' + DIRS[i][1] + 's;animation-timing-function:linear;animation-iteration-count:infinite');
    for (var k = 0; k < 4; k++) {            /* the sequence four times, shifted by exactly -25%: the loop has no seam */
      for (var j = 0; j < items.length; j++) {
        var n = items[j];
        track.appendChild(make('span', 'wb-proof-logo', "font-family:var(--font-core);font-size:calc(clamp(20px,1.55vw,27px) * " + n[1] + ");font-weight:800;letter-spacing:-.02em;white-space:nowrap;color:var(--ink-700);opacity:.62;transition:opacity var(--dur-base) var(--ease-standard),color var(--dur-base) var(--ease-standard)", n[0]));
      }
    }
    vp.appendChild(track);
    var holder = make('div', 'wb-proof-row-' + (i + 1), 'min-width:0');
    holder.appendChild(vp);
    return holder;
  }

  function build() {
    var sec = make('section', '', 'background:var(--wb-cream);border-top:1px solid var(--border-hairline);border-bottom:1px solid var(--border-hairline);padding:clamp(34px,3.6vw,54px) 0;overflow:hidden');
    sec.id = 'social-proof';
    var head = make('div', 'wrap', 'display:flex;flex-direction:column;align-items:center;gap:10px;margin-bottom:clamp(22px,2.2vw,32px)');
    head.appendChild(make('span', 'mono', 'letter-spacing:.16em;text-transform:uppercase;color:var(--wb-orange);font-size:13px;font-weight:800', 'D\u00e9ploy\u00e9 \u00e0 grande \u00e9chelle'));
    head.appendChild(make('h2', '', 'font-size:clamp(22px,2.5vw,40px);line-height:1.12;letter-spacing:-.02em;text-align:center;color:var(--wb-charcoal);white-space:nowrap;margin:0', 'Notre syst\u00e8me AI Phone r\u00e9pond aux appels de\u00a0:'));
    sec.appendChild(head);
    var grid = make('div', '', 'display:grid;grid-template-columns:minmax(0,1fr);gap:clamp(22px,2.4vw,34px)');
    for (var i = 0; i < ROWS.length; i++) grid.appendChild(row(ROWS[i], i));
    sec.appendChild(grid);
    return sec;
  }

  function mountAll() {
    var slots = document.querySelectorAll('#wb-proof-slot:empty');
    if (!slots.length) return;
    if (!document.getElementById('wb-proof-css')) { var st = document.createElement('style'); st.id = 'wb-proof-css'; st.textContent = CSS; document.head.appendChild(st); }
    for (var i = 0; i < slots.length; i++) slots[i].appendChild(build());
  }

  var queued = false;
  function queue() { if (queued) return; queued = true; requestAnimationFrame(function () { queued = false; mountAll(); }); }
  /* the product page draws its content a moment after load (and redraws it as the visitor chooses): keep an eye out for an empty slot */
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mountAll); else mountAll();
  if (window.MutationObserver) new MutationObserver(queue).observe(document.documentElement, { childList: true, subtree: true });
})();
